import { IObservalibilityState, Types } from './types';
import { Reducer } from 'redux';

const INITIAL_STATE: IObservalibilityState = {
  initialized: false
};

type TCustomAction = {
  type: Types;
  payload: {
    initialized: boolean;
  };
};

const reducer: Reducer<IObservalibilityState, TCustomAction> = (
  state = INITIAL_STATE,
  action
) => {
  switch (action.type) {
    case Types.SET_OBSERVABILITY_INITIALIAZED_SUCCESS:
      return {
        initialized: true
      };
    default:
      return state;
  }
};

export default reducer;
